/***********************************************************
* CUSTOM COMPARATORS FOR BGG LIST
***********************************************************/

export const endDateComparator = (date1, date2) => {
    // Handle null/undefined values
    if (!date1 && !date2) return 0;
    if (!date1) return 1; // Null dates go last
    if (!date2) return -1;
    
    // Convert the dates to timestamps for comparison
    const timestamp1 = date1 instanceof Date ? date1.getTime() : new Date(date1).getTime();
    const timestamp2 = date2 instanceof Date ? date2.getTime() : new Date(date2).getTime();
    
    // Handle invalid dates
    if (isNaN(timestamp1) && isNaN(timestamp2)) return 0;
    if (isNaN(timestamp1)) return 1;
    if (isNaN(timestamp2)) return -1;
    
    // Compare the timestamps
    return timestamp1 - timestamp2;
}

export const dealScoreComparator = (dealScore1, dealScore2) => {
    // Handle cases where dealScore is not available or incomplete
    if ((!dealScore1 || dealScore1.score === null || dealScore1.score === "" || dealScore1.score === "?" || dealScore1.score === "N/A" || dealScore1.score === "Loading...") &&
        (!dealScore2 || dealScore2.score === null || dealScore2.score === "" || dealScore2.score === "?" || dealScore2.score === "N/A" || dealScore2.score === "Loading...")) return 0;
    if (!dealScore1 || dealScore1.score === null || dealScore1.score === "" || dealScore1.score === "?" || dealScore1.score === "N/A" || dealScore1.score === "Loading...") return 1;
    if (!dealScore2 || dealScore2.score === null || dealScore2.score === "" || dealScore2.score === "?" || dealScore2.score === "N/A" || dealScore2.score === "Loading...") return -1;
    
    // Compare based on the percentage score
    const score1 = parseFloat(dealScore1.score);
    const score2 = parseFloat(dealScore2.score);
    
    if (score1 > score2) return 1;
    if (score1 < score2) return -1;
    return 0;
}

export const OtherListingComparator = (count1, count2) => {
    if (count1 > count2) return 1;
    if (count1 < count2) return -1;
    return 0;
}

export const LocationComparator = (location1, location2) => {
    if ((!location1 || location1.city === "" || location1.state === "") && (!location2 || location2.city === "" || location2.state === "")) return 0;
    if (!location1 || location1.city === "" || location1.state === "") return 1;
    if (!location2 || location2.city === "" || location2.state === "") return -1;
    
    if (location1.distance && location2.distance) {
        if (location1.distance > location2.distance) return 1;
        if (location1.distance < location2.distance) return -1;
        return 0;
    }
    if (!location1.distance && !location2.distance) return 0;
    if (!location1.distance && location2.distance) return -1;
    if (location1.distance && !location2.distance) return 1;
    
    return location1.city.toLowerCase().localeCompare(location2.city.toLowerCase());
}
